import Cookies from 'js-cookie'

const cartIds = 'cartids'

const twoCatId = 'twocatid'

const catId = 'catid'

const home = 'ha'

const userKey = 'user'

var c_start

var c_end


export function getCartIds() {
    return Cookies.get(cartIds)
}

export function removeCartIds() {
    return Cookies.remove(cartIds)
}

export function setCartIds(ids) {
    return Cookies.set(cartIds, ids)
}

export function getTwoCatId() {
    return Cookies.get(twoCatId)
}

export function removeTwoCatId() {
    return Cookies.remove(twoCatId)
}

export function setTwoCatId(twocatid) {
    return Cookies.set(twoCatId, twocatid)
}

export function getCatId() {
    return Cookies.get(catId)
}

export function setCatId(catid) {
    return Cookies.set(catId, catid)
}

export function getHomeActive() {
    return Cookies.get(home)
}

export function setHomeActive(ha) {
    return Cookies.set(home, ha)
}

export function getUser() {
    return Cookies.get(userKey)
}

export function setUser(user) {
    return Cookies.set(userKey, user)
}

export function getCode() {
    return Cookies.get('spmCode')
}

export function setCode(code) {
    return Cookies.set("spmCode", code)
}

export function setDeptId(did) {
    return Cookies.set("spmDeptId", did)
}

export function getDeptId() {
    return Cookies.get('spmDeptId')
}

export function setYqUrl(url) {
    return Cookies.set("yqurl", url)
}

export function getYqUrl() {
    return Cookies.get('yqurl')
}
export function removeYqUrl() {
    return Cookies.remove('yqurl')
}

export function setDeptName(name) {
    return Cookies.set("spmDnm", name)
}

export function getDeptName() {
    return Cookies.get('spmDnm')
}

// export function getDeptId() {
//     // return 'ABF95F4D9D814C5ABF19AD8FCCC29D59' //寇兰大
//     return '463468A3E8BD4CBDBCCBB5A2BA595F45' //大展
// }

//设置cookie
export function setCookie(key, value, expiredays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = key + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
}

//取回cookie
export function getCookie(key) {
    if (document.cookie.length > 0) {
        c_start = document.cookie.indexOf(key + "=");
        if (c_start != -1) {
            c_start = c_start + key.length + 1;
            c_end = document.cookie.indexOf(";", c_start);
            if (c_end == -1) {
                c_end = document.cookie.length;
            }
            return unescape(document.cookie.substring(c_start, c_end));
        }
    }
    return "";
}

export function delCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

export function formatDate(date, format) {
    const year = date.getFullYear();
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const day = ("0" + date.getDate()).slice(-2);
    const hours = ("0" + date.getHours()).slice(-2);
    const minutes = ("0" + date.getMinutes()).slice(-2);
    const seconds = ("0" + date.getSeconds()).slice(-2);
    return format.replace(/yyyy/g, year)
        .replace(/mm/g, month)
        .replace(/dd/g, day)
        .replace(/hh/g, hours)
        .replace(/mi/g, minutes)
        .replace(/ss/g, seconds);
}

